import React, { useEffect, useState } from 'react';

import Button from 'xpi-black-ui/Base/Button';
import Slider from 'xpi-black-ui/Base/Slider';
import Loading from 'xpi-black-ui/Base/Loading';
import { P } from 'xpi-black-ui/Base/Typography'
import { Col, Row } from 'xpi-black-ui/Base/Grid';
import KeyValue from 'xpi-black-ui/Common/KeyValue';
import ContentBox from 'xpi-black-ui/Base/ContentBox';

import Legs from './compose/Legs';
import Price from './compose/Price';
import Footer from './compose/Footer';

import waConfig from 'utils/waConfig';
import { hasAssetBuy } from 'utils/helpers';

import { ContainerTypeStrike, ContainerPrice, Container, ContainerButtons } from './styles';
import { typesStrikeEnum } from '../../../../enums';

function Configuration({
  legs,
  saveQuote,
  priceInfo,
  updateLeg,
  removeLeg,
  addNewLegs,
  loadingPrice,
  setPriceInfo,
  onUpdatePrice,
  alreadyQuoted,
  isQuoteUpdate,
  clickCleanQuote,
  enableUpdatePrice,
}) {
  const [quoteName, setQuoteName] = useState('');
  const [typeStrike, setTypeStrike] = useState(typesStrikeEnum.amount);

  const hasPrice = Object.keys(priceInfo || {})?.length > 0;
  const updatePrice = alreadyQuoted && hasPrice;

  const onSetTypeStrike = (value) => {
    setTypeStrike(value[0]);
  };

  const onUpdateLeg = (props) => {
    if (priceInfo) {
      setPriceInfo({});
    }

    updateLeg(props);
  }
  const onRemoveLeg = (props) => {
    if (priceInfo) {
      setPriceInfo({});
    }
    removeLeg(props);
  };


  const createQuoteName = (configuration) => {
    let name = `${configuration?.asset} - `;
    name += configuration.reverse ? 'Rolagem de ' : '';
    name += `${configuration.nameStructure} `;
    name += (configuration.reverse && !configuration.buyAsset) || !configuration.hasStockInStrategie
      ? ''
      : hasAssetBuy(configuration.buyAsset);

    setQuoteName(name);
  };

  useEffect(() => {
    const configuration = legs[0];
    createQuoteName(configuration);

    if (configuration?.reverse) {
      setTypeStrike(typesStrikeEnum.amount);
    }
  }, [legs]);

  const onSaveQuote  = () => {
    saveQuote({ quoteName });
  }

  return (
    <Container>
      <div style={{ marginBottom: '24px '}}>
        <Row justifyContent="space-between" align="flex-start">
          <Col>
            <P bigger>
              <KeyValue
                value={quoteName}
                className="key-value"
                title="Nome da cotação:"
              />
            </P>
          </Col>
          <Row align="flex-start">
            {legs[0]?.reverse
              ? <P style={{ textAlign: 'right', fontSize: '12px' }}>*Cotações de rolagem não podem ser em percentual.</P>
              : (
                <KeyValue
                  className="key-value"
                  title="Método de cotação:"
                  value={
                    <ContainerTypeStrike>
                      <P>R$</P>
                      <Slider
                        step={1}
                        range={{ min: 0, max: 1 }}
                        onUpdate={(e) => onSetTypeStrike(e)}
                      />
                      <P>%</P>
                    </ContainerTypeStrike>
                  }
                />
              )}
          </Row>
        </Row>
      </div>

      <Legs
        legs={legs}
        updateLeg={onUpdateLeg}
        removeLeg={onRemoveLeg}
        typeStrike={typeStrike}
        addNewLegs={addNewLegs}
        updatePrice={updatePrice}
      />

      <ContainerButtons>
        <Row justifyContent="flex-end">
          <Col className="button-clean">
            <Button
              onClick={() => clickCleanQuote()}
              data-wa={waConfig.event.customQuotes.clear}
              style={{ marginRight: '14px', background: '#2e3136'}}
            >
              Limpar cotação atual
            </Button>
          </Col>
          <Col>
            <Button
              primary
              onClick={() => onUpdatePrice()}
              data-wa={waConfig.event.customQuotes.quote}
              disabled={!enableUpdatePrice || loadingPrice}
            >
              {updatePrice
                ? 'Atualizar preço'
                : 'Realizar cotação'
              }
            </Button>
          </Col>
        </Row>
      </ContainerButtons>

      {priceInfo && (
        <>
          <ContainerPrice>
            {hasPrice && (
              <ContentBox className="date-quote">
                <P style={{ textAlign: 'center' }}>Cotação realizada às {priceInfo?.dateTimeQuote}</P>
              </ContentBox>
            )}

            <Row justifyContent="space-between">
              <Price
                priceInfo={priceInfo}
                setPriceInfo={setPriceInfo}
                loadingPrice={loadingPrice}
              />
            </Row>
          </ContainerPrice>
          <Footer
            hasPrice={hasPrice}
            saveQuote={onSaveQuote}
            isQuoteUpdate={isQuoteUpdate}
          />
        </>
      )}

      {!priceInfo && loadingPrice && (
        <Loading text="Carregando..." style={{ height: '150px', paddingBottom: '40px' }} />
      )}
    </Container>
  );
}

export default Configuration;
